module.exports = __webpack_public_path__ + "static/2005-layer-2-ad99edff14141f915f51a2c9913e5e93.png";